export default "table {\n    width: 100%;\n}\n\nth.mat-sort-header-sorted {\n    color: black;\n}";